import type { PropType } from 'virtual-vue';
import type { NoticeBarSuffixIconType, NoticeBarTheme } from './notice-bar';

export const props = {
  /**
   * 类型
   * @default 'default'
   */
  theme: {
    type: String as PropType<NoticeBarTheme>,
    default: 'default',
  },
  /**
   * 右侧icon
   */
  suffixIcon: {
    type: String as PropType<NoticeBarSuffixIconType>,
    default: undefined,
  },
  /**
   * 内容
   */
  content: {
    type: String,
    default: '',
  },
  /**
   * 操作文本
   */
  operation: {
    type: String,
    default: '',
  },
  /**
   * 是否圆角展示
   */
  rounded: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
};
